import { useMap } from '@vis.gl/react-google-maps';
import React, { useEffect } from 'react';
import { Marker, Zone } from '../interface';

interface MapBoundaryProps {
  zones: Zone[];
  searchedMarkerPosition: { lat: number; lng: number } | null;
  companies?: Marker[];
  focusOnSearchedMarker?: boolean; // If true, the map will center on the searched marker position and zoom in, else the map will fit all the points in the map
}

const MapBoundary: React.FC<MapBoundaryProps> = ({ zones = [], searchedMarkerPosition, companies, focusOnSearchedMarker = false }) => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    const bounds = new window.google.maps.LatLngBounds();

    if (searchedMarkerPosition) {

      if (focusOnSearchedMarker) {
        map.setCenter(
          new window.google.maps.LatLng(searchedMarkerPosition.lat, searchedMarkerPosition.lng),
        );
        map.setZoom(12);
        return;
      }

      bounds.extend(
        new window.google.maps.LatLng(searchedMarkerPosition.lat, searchedMarkerPosition.lng),
      );
    }

    const coordinates = zones.map((zone) => zone.coordinates).flat();

    if (coordinates.length) {
      for (const xy of coordinates) {

        if (!xy) continue;

        const latLag = new window.google.maps.LatLng(xy.lat, xy.lng);

        if (!latLag) continue;

        bounds.extend(latLag);
      }
    }

    if (companies && companies.length) {
      const companyCoordinates = companies.map((company) => company?.coordinate).flat();

      for (const xy of companyCoordinates) {
        if (!xy) continue;

        const latLag = new window.google.maps.LatLng(xy.lat, xy.lng);

        if (!latLag) continue;

        bounds.extend(latLag);
      }
    }

    if (!bounds.isEmpty()) {
      map.fitBounds(bounds, 48);
    }
  }, [map, zones, searchedMarkerPosition]);

  return null;
};

export default React.memo(MapBoundary);
